import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, File, Download } from 'lucide-react';
import styles from './FolderDetail.module.css';
import bgPattern from '../../../../Assets/BRANDING-BG.png';
import { Header } from '../header/Header';
import { DashboardSidebar } from '../DashboardSidebar/DashboardSidebar';

const GENERAL_FILES = [
    {
        id: 1,
        name: 'Monthly Service Review - December 2025.pptx',
        type: 'pptx',
        size: '5.2 MB',
        uploadedDate: 'Jan 05, 2026'
    },
    {
        id: 2,
        name: 'Incident Response Procedures.docx',
        type: 'docx',
        size: '856 KB',
        uploadedDate: 'Dec 15, 2025'
    }
];

export const GeneralDocumentsFolder = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.headerWrapper}>
                <Header onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
            </div>

            <div className={styles.mainWrapper}>
                <DashboardSidebar
                    isOpen={isSidebarOpen}
                    onClose={() => setIsSidebarOpen(false)}
                />

                <div className={styles.container} style={{ backgroundImage: `url(${bgPattern})` }}>
                    <div className={styles.pageHeader}>
                        <div className={styles.headerLeft}>
                            <button
                                className={styles.backButton}
                                onClick={() => navigate('/dashboard/qbr')}
                            >
                                <ArrowLeft size={20} />
                                Back to QBR & Shared Materials
                            </button>
                            <h1 className={styles.title}>General Documents</h1>
                            <p className={styles.subtitle}>
                                General documentation, procedures, and reference materials.
                            </p>
                        </div>
                        <div className={styles.headerRight}>
                            <span className={styles.fileCount}>{GENERAL_FILES.length} files</span>
                        </div>
                    </div>

                    <div className={styles.filesGrid}>
                        {GENERAL_FILES.map((file) => (
                            <div key={file.id} className={styles.fileCard}>
                                <div className={styles.fileIconContainer}>
                                    <File size={48} />
                                    <span className={styles.fileType}>{file.type}</span>
                                </div>
                                <div className={styles.fileInfo}>
                                    <h3 className={styles.fileName}>{file.name}</h3>
                                    <div className={styles.fileMeta}>
                                        <span className={styles.fileSize}>{file.size}</span>
                                        <span className={styles.separator}>•</span>
                                        <span className={styles.fileDate}>{file.uploadedDate}</span>
                                    </div>
                                </div>
                                <button className={styles.downloadButton}>
                                    <Download size={18} />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GeneralDocumentsFolder;
